import React, { useState, useEffect } from 'react';
import { Form, Button, Table, Select, Card, Row, Col, Typography, Spin, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';
import { API_BASE_URL } from '../constants/api';
import './Reports.css';

const { Option } = Select;
const { Title } = Typography;

const RepositoryReport = () => {
  const [form] = Form.useForm();
  const [repositories, setRepositories] = useState([]);
  const [loadingRepositories, setLoadingRepositories] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [loadingReport, setLoadingReport] = useState(false);
  const [selectedRepository, setSelectedRepository] = useState(null);

  useEffect(() => {
    fetchRepositories();
  }, []);

  const fetchRepositories = async () => {
    setLoadingRepositories(true);
    try {
      const response = await axios.get(`${API_BASE_URL}Repository/List`);
      if (response.data.code === 0) {
        setRepositories(response.data.data || []);
      }
    } catch (error) {
      console.error('Failed to fetch repositories:', error);
    } finally {
      setLoadingRepositories(false);
    }
  };

  const handleSearch = async () => {
    try {
      const values = await form.validateFields();
      const { repositoryId } = values;

      if (!repositoryId) {
        return;
      }

      setSelectedRepository(repositoryId);
      setLoadingReport(true);

      const response = await axios.get(`${API_BASE_URL}Reports/ReportRepository`, {
        params: {
          repositoryId
        }
      });

      if (response.data.code === 0) {
        setReportData(response.data.data || []);
      }
    } catch (error) {
      console.error('Report fetch error:', error);
    } finally {
      setLoadingReport(false);
    }
  };

  const tableColumns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      width: 50,
      render: (_, __, index) => index + 1
    },
    {
      title: 'كود المادة',
      dataIndex: 'materialCode',
      key: 'materialCode',
      width: 120
    },
    {
      title: 'اسم المادة',
      dataIndex: 'materialName',
      key: 'materialName',
      width: 250
    },
    {
      title: 'الكمية',
      dataIndex: 'quantity',
      key: 'quantity',
      width: 120,
      render: (val) => <b>{Number(val).toLocaleString()}</b>
    }
  ];

  const totalQuantity = reportData.reduce((acc, item) => {
    acc += item.quantity || 0;
    return acc;
  }, 0);

  return (
    <div className="report-container">
      <Card size="small" className="report-filter-card">
        <Form form={form} layout="inline" className="report-filter-form">
          <Form.Item name="repositoryId" label="المستودع" rules={[{ required: true, message: 'يرجى اختيار المستودع' }]} className="report-form-item">
            <Select
              placeholder="اختر المستودع"
              loading={loadingRepositories}
              showSearch
              allowClear
              size="small"
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={repositories.map(repo => ({
                label: `${repo.name} (${repo.id})`,
                value: repo.id
              }))}
            />
          </Form.Item>
          <Form.Item className="report-form-item report-btn-item">
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={handleSearch}
              loading={loadingReport}
              size="small"
            >
              تنفيذ
            </Button>
          </Form.Item>
        </Form>
      </Card>

      {reportData.length > 0 && (
        <>
          <Card size="small" className="report-table-card">
            <Spin spinning={loadingReport}>
              <Table
                columns={tableColumns}
                dataSource={reportData}
                rowKey="materialId"
                pagination={{ pageSize: 20 }}
                scroll={{ x: 'max-content' }}
                size="small"
              />
            </Spin>
          </Card>
        </>
      )}
    </div>
  );
};

export default RepositoryReport;
